import React from "react";
import CollapsibleCard from "../../../ForBrands/ui/CollapsibleCard";
import InsightList from "../../../ForBrands/ui/InsightList";
import { LegendRow } from "../../../ForBrands/ui/LegendItem";
import RangeTrack from "../../../ForBrands/ui/charts/RangeTrack";
import { CONSISTENCY_LEGEND } from "./athletePerformanceModel";

// Consistency (Jayson's A5, spec B3 f): each main stat's game-to-game range
// on one track (lowest to highest game, the middle half of the games, the
// per-game average with its value; every number printed, the row said in
// words for screen readers), the scoring thresholds ("20+ pts games, 6 of
// 14") and the Consistency read. `view` is
// athletePerformanceModel.consistencyView().

const ConsistencyCard = ({ view, cardProps = {} }) => (
  <CollapsibleCard title="Consistency" subtitle={view.lede} {...cardProps}>
    {view.rows.length > 0 && (
      <>
        <div className="flex flex-col">
          {view.rows.map((r) => (
            <RangeTrack key={r.key} label={r.label} min={r.min} p25={r.p25} p75={r.p75} max={r.max} mean={r.mean} typicalNote={r.typicalNote} />
          ))}
        </div>
        <LegendRow items={CONSISTENCY_LEGEND} label="Consistency legend" />
      </>
    )}
    {view.thresholds.length > 0 && (
      // eslint-disable-next-line jsx-a11y/no-redundant-roles -- VoiceOver drops the list role of a list with no bullets
      <ul role="list" aria-label="Scoring thresholds" className="flex flex-wrap gap-2">
        {view.thresholds.map((t) => (
          <li key={t.key} className="inline-flex h-8 items-center gap-2 rounded-full border border-bm-border bg-white px-3 bm-label-xs text-bm-ink">
            {/* The space keeps the words apart for screen readers ("10+ pts games 10 of 14"); the flex gap draws it. */}
            {t.label}{" "}
            <span className="font-bold tabular-nums text-bm-info">{t.count}</span>
          </li>
        ))}
      </ul>
    )}
    <InsightList insights={view.insights} variant="read" label="Consistency read" />
  </CollapsibleCard>
);

export default ConsistencyCard;
